export const DEFAULT_LANGUAGE = 'en';
export const BLOG_LANGUAGES = [
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'fi',
    'fr',
    'he',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'ms',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'zh',
    'vi',
    'lv',
    'hr',
];
//# sourceMappingURL=blog-languages.js.map